<template>
    <div style="background:white" class="ve-list-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1394', '来料质检-汇总') }}</div>
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1393', '来料质检-明细') }}</div>
            </div>
        </div>
        
        <div v-show="actitem=='two'" class="ve-list-page__body">
            <item-two></item-two>
        </div>
        <div v-show="actitem=='one'" style=" display:flex; width:100%;min-width:1300px; background:#fff;line-height:30px;height:38px;border-bottom:2px solid #389;padding-top:3px">
            <div style="line-height:30px;margin-left:5px;margin-right:4px;font-size:12px;font-weight:600">{{ $LANG('0120', '查询字段') }}</div>
            <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:130px; ">
                <span v-for="item in tabArr" :key='item.key' >
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:320px; height:30px; ">
                <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                    </span>
                </el-select>
                <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
            </el-input>
            <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
            <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
        </div> 
        <div v-show="actitem=='one'" style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:2px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"               
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="po_stkchk"
                    ref="tableRef"
                >
            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:86vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-div">
                        <span class="oneRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  >  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem   :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <template slot="label" ><span v-if="item.key=='SHPDTTM'" style="color:red;margin-right:8px">*</span>{{ $translate.getColTitle(item, $store.state.lang) }}</template>
                                <el-date-picker size="medium" :disabled="saveFlag||item.DISABLED==='Y'?true:false" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" border disabled v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-div">
                    <span class="oneRow"> {{ $LANG('0966', '质检明细') }} </span>
                </div>
                <el-table  :data="dtlData" 
                    border       
                    class="custom-table-border"                     
                    size="small"
                    ref="refdtl"
                    show-summary
                    v-loading="v_loading"
                    :element-loading-text="$LANG('2030', '数据加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(100, 100, 100, 0.8)"
                    :cell-style="{padding:'2px','font-size':'12px'}"
                    style="margin-top:-8px"
                    :summary-method="getMatSum"
                    :height="editHeight" 
                    highlight-current-row >  
                    <el-table-column :label="$LANG('0310', '序号')" type='index' width="55" fixed></el-table-column>
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'&&item.key!=='RN'"
                        :min-width="item.width">
                        <template slot="header">{{item.title}}<span v-if="item.notnull=='Y'" style="color:red">*</span></template>
                        <template  slot-scope="scope" >
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" disabled false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                <span v-else-if="item.key=='QCRESULT'"  >{{scope.row['QCRESULTNM']}}</span>
                                <span v-else  >{{scope.row[item.key]}}</span>
                            </span>
                            <span v-else > 
                                <el-input type="number" @input="numQty(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"   v-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                                <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                <el-select size="mini" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="scope.row[item.key]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-input  v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>   
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template>
                    </el-table-column> 
 
                </el-table>
             
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button @click="saveRec" :disabled="saveFlag" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
  
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
 
        <!-- 质检明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="poWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1166', '下推质检明细') }}</span>
            </div> 
            <div style="height:86vh;overflow-y:auto">
            <div class="one-toolbar">
                <span class="spanRow"  ></span> 
                <el-checkbox @change="selEvent" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px; "><span style="font-size:12px;color:white">{{ $LANG('0263', '全选') }}</span></el-checkbox>
                <span style="margin-left:6px">{{ $LANG('0298', '字段') }}</span>
                <el-select v-model="selparam4"  :placeholder="$LANG('1675', '请选择列名')"   size="small" style="width:150px; margin-left:4px">
                    <span v-for="(item,index) in stkCol" :key='index' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="qryDtl" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper4" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryDtl" ></el-button>
                </el-input>
                <el-button type="primary" @click="nextCate" size="small" icon="iconfont icon-shipeiqi" style=" margin-left:10px;height:30px;margin-top:2px;line-height:15px">{{ $LANG('1168', '下推选择记录') }}</el-button>
            </div>
            
            <el-table  :data="dtlData.filter(item=>item.ISNEXT=='N')" 
                border                            
                size="small"
                class="custom-table-border"
                :row-key="getDtlKey"
                :cell-style="{padding:'2px'}"
                :height="400" 
                cell-class-name="clearPadding"
                highlight-current-row > 
                <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <!-- <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.key=='STKQTY' "  v-model="scope.row[item.key]" size="mini" style="width:100%"></el-input> -->
                        <el-input v-else-if="item.key=='RMK'" v-model="scope.row[item.key]" size="mini" style="width:100%" clearable></el-input>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
            </el-table>
            <el-table  :data="nextData" 
                border                            
                size="small"
                ref="refreq"
                class="custom-table-border"
                :cell-style="{padding:'2px'}"
                :row-key="getDtlKey"
                :height="maxHeight" 
                highlight-current-row >               
                <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.key=='CHKAMT'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    :label="$LANG('0330', '操作')"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-button size="mini"  type="text" icon="el-icon-close" @click="nextDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="poWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button @click="genStk" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >{{ $LANG('1115', '生成入库单') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate, getDate2 } from '../../api/Select' 
import repWin from '../datamgt/repWin.vue'  
import itemTwo from './po_stkchk_two.vue'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
//局部注册
export default {
    name:"po_stkcheck",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '450125',
            fieldIdseq: '450125',
            fieldLstseq: '1',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            columnHiddenOptionKey: 'columnHiddenOption',
        })
    ],
    data () {
        return {
            poWin:false,
            v_dttm:'',
            v_rmk:'',
            stkData:[],
            repDlg:false,
            selAll:'N',
            allSel:'N',
            allNext:'N',
            isSame:'N',
            v_stkqty:'',
            v_stkrmk:'',
            v_poqty:'',
            v_poprc:'',
            v_rate:'',
            nextData:[],
            v_idseq:'',
            loading:false,
            v_selAll:'N',
            repWin:false,
            repUrl:'',
            stkCol:[],
            addWin:false,
            perFlag:'create',
            dtlRow:{},
            sendVal:'PRD',
            saveFlag:false,
            empWin:false,
            promptWin:false,
            prompt:'',
     
            tmplRmk:'',
            stfgCss:'',
 
            stfgColor:'',
            mainRow:{},
            input_hold:this.$LANG('1718', '请输入查询的值'),
 
            active:'', //二级菜单选中标志
            stfg_:'ALL',
            menuBool:false,
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            v_loading:false,
            formArr:[],
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            dtlData:[], //明细数据
            dtlCol:[],
            operArr:[],
            oper:'like',
            oper2:'like',
            comboArr:{},
            txtparam:'',
            selparam:'IDNO',
 
            txtparam3:'',
            selparam3:'',
            txtparam4:'',
            selparam4:'',
            oper4:'like',
            delArr:[],
            repArr:[],
            rowIndex:'-1',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            dataCount:0,
 
            notNull:[],
 
            v_replist:[],
            v_idno:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_rowIndex:'',
            stfgNo :'',
            stfgNm:'',
            v_row:{},
            v_index:'',
            v_tabindex:'',
            v_tabrow:{},
            pageList: [100,500,1000],
            pageSize:100,
            maxHeight:'',
            pageIndex:1,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,
                
            },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    if (row['ISBAD']=='Y' ){
                        return 'table-body-cell-red'
                    }else{
                        return "table-body-cell-class1" 
                    }
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            loadingInstance: null,
            v_sort:'asc',
            startRowIndex: 0,
            vueCol:[],
            initCol:[],
            actitem:'one',
 
        }
    },
    mounted () { 
        this.maxHeight = document.documentElement.clientHeight - 170
         
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //表单所以下拦框动态赋值
        this.comSelect()
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','450125','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','450125','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            if (res.code==='200'){
                this.formArr = res.result             
            }else{
                this.promptWin=true
                this.prompt=res.result
            }
        })
        //动态生成表单验证规则
        
        this.$nextTick(()=>{
            this.$refs['refinput'].focus()
        })
    },
    computed: {
        editHeight: function() {
            return (window.innerHeight - 350) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        }, 
    },
    components: {
        repWin,
        itemTwo,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#po_stkchk"),
                name: "wave",
            })
            //查询数据
            this.initPriv()
            this.getTabField() //表列字段
    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        numQty(row,index,key){
            if (row['QCQTY'] ){
                row['STKQTY'] =Number(row['ACTQTY']) -Number(row['QCQTY'])
            }else{
                row['STKQTY'] =Number(row['ACTQTY'])
            }
        },
        itemClick(val){
            this.actitem =val     
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
 
        },

        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]==null?'':a[v_key].toUpperCase() 
                    let nameB = b[v_key]==null?'':b[v_key].toUpperCase()    
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        rowShow(){
            this.v_inputrow={}
            this.qryTabData()
        } ,
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr

            // this.repWin =true
            // this.repUrl =this.$store.state.repUrl+ 'check/po_stkchk.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
        },
        initPriv(){
            //用户表单新增、编辑、审核、作废权限 :frmid:  ID
            getBaseData('xuper_auth/getBaseData','idseq',this.$cookies.get('v_idseq') ,'frmidseq','450125','v_sys_user_priv',' and issel=\'Y\'').then(res=>{                 
 
                this.getOrdList(' and icdttm>=\''+getDate2(30)+'\'')
                if (this.v_admin==='N') { //表示有权限控制
                    let row =res.result[0]
                    if (row.ISADD==='N'){ //新增
                        this.addBool=true
                    }if (row.ISUPD==='N'){ //修改
                        this.editBool=true
                    }if (row.ISDEL==='N'){ //删除
                        this.delBool=true
                    }if (row.ISCFM==='N'){ //审核
                        this.cfmBool=true
                    }if (row.ISCANCEL==='N'){ //下推
                        this.cancelBool=true
                    }                  
                }
            }) 
        },
        //下推入库单f 
        nextGen(row ){
            this.poWin=true
            this.getNextData(row['IDSEQ'])
            this.selAll='N'
            this.nextData=[]
        },
        //生成入库单
        genStk(){
            let v_qtyFlag =false  
 
            if (this.nextData.length==0){
               this.promptWin =true
               this.prompt =this.$LANG('1641', '下推记录为空')
            }else{
                this.nextData.some(item=>{
                    if (!item['STKQTY'] ||item['STKQTY']==0 ){
                        v_qtyFlag =true
                    }
                })
                if (v_qtyFlag){
                    this.promptWin =true
                    this.prompt =this.$LANG('0814', '请检查下推记录：质检数量')+'>0'
                }else {
                    this.$confirm(this.$LANG('1601', '你确定要下推生成入库单吗'),this.$LANG('1442', '提示'),{
                        confirmButtonText: this.$LANG('1638', '确定'),
                        cancelButtonText:this.$LANG('0132', '取消'),
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        let v_json =JSON.stringify(this.nextData)
                        let v_action =this.v_username+getDate('full')
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/next_genstk',
                            data: { corpid:this.v_corpid,p_json: v_json,p_user: this.v_username,p_action:v_action},
                        }).then(res=>{ 
                            if (res.code=='200'){        
                                this.$notify({
                                    title: this.$LANG('1441', '成功'),
                                    message: this.$LANG('1482', '已成功下推入库单，请到采购入库单界面中查看'),
                                    type: 'success'
                                })
                            }else{
                                this.promptWin =true
                                this.prompt =this.$LANG('1446', '下推失败！')+res.result
                            }
                            this.poWin =false
                        })
                    }).catch(()=>{})   
                }             
            }
        },
        nextDel(row,index){
            this.dtlData.push(JSON.parse(JSON.stringify( Object.assign(row,{ISNEXT:'N', SEL:'N'}))))
            this.nextData.splice(index,1)          
        },
        //下推分配
        nextCate(){
            if (this.dtlData.filter(item=>item.SEL=='Y').length >0) {
                this.dtlData.forEach((item,index)=>{
                    if (item.SEL=='Y' &&item['ISNEXT']=='N' ){    
                        let v_inqty =0 ,v_poqty=0,v_stkqty=0  //已入库数 ,采购数，收货数
                        if (item['INQTY']){  //已入库数
                            v_inqty =Number(item['INQTY'])
                        }
                        if (item['STKQTY']){  //质检数
                            v_stkqty =Number(item['STKQTY'])
                        }
                         if (item['QTY']){  //采购数
                            v_poqty =Number(item['QTY'])
                        }
                        let v_over =Number(v_inqty+v_stkqty -v_poqty)
                        if (v_over>0 ) {
                            this.$confirm(this.$LANG('0547', '产品编码：')+item['MATNO']+this.$LANG('0809', '已入库数量已超出采购数量')+v_over+this.$LANG('1571', '，要继续下推吗？'),this.$LANG('1442', '提示'),{
                                confirmButtonText: this.$LANG('1638', '确定'),
                                cancelButtonText:this.$LANG('0132', '取消'),
                                customClass:'messageBox',
                                showClose:false,
                                type:'info',
                            }).then(()=>{
                                this.dtlData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))
                                this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                            }).catch(err =>{})
                        }else {                          
                            this.dtlData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'Y',SEL:'N'}))))                        
                            this.nextData.push(JSON.parse(JSON.stringify(Object.assign(item,{ISNEXT:'N','SEL':'N'}))))
                        }
                    }           
                })
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1684', '请选择记录')
            }
        },
        selEvent(){
            this.dtlData.forEach(item=>{
                item['SEL']=this.selAll
            })
        },
 
        enterDown(event){
            if (event.keyCode==13){
                this.qryTabData()
            }
        },
 
        //保存记录
        saveRec(){
            let v_bool =false
            this.dtlData.forEach(item=>{
                if (!item['QCRESULT']){
                    v_bool =true
                }
            })
            if (v_bool){
                this.promptWin =true
                this.prompt =this.$LANG('1893', '明细记录的')+this.$LANG('1291', '质检结果')+this.$LANG('2051', '不能为空')
            }else{
                var vm =this 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(vm.mainRow), p_table:'IC_STK'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        //明细保存：批量保存  res.idseq
                            this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'ic_stkdtl',p_idseq:res.idseq,p_action:'S' },
                            }) 
        
                        vm.addWin =false   
                        vm.getOrdList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },
        //状态审核
        recSet(row,val){
            //审核前判定明细 质检结果不为空
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'IC_STKDTL',p_cond:' and (qcresult is null or stkqty is null)'},
            }).then(res=>{ 
                if (val =='Y' && res.result.length>0){
                    this.prompt =this.$LANG('1909', '明细记录的质检结果或质检合格数为空时，不能审核')
                    this.promptWin =true
                }else {
                    let stfg_ =val=='Y'?this.$LANG('0134', '审核'):val=='N'?this.$LANG('0137', '弃审'):this.$LANG('0257', '作废')
                    let v_dttm =val=='Y'? getDate('full') :''
                    this.$confirm(this.$LANG('1564', '你确定要')+stfg_+this.$LANG('1566', '此行记录吗'),this.$LANG('1442', '提示'),{
                        confirmButtonText: this.$LANG('1638', '确定'),
                        cancelButtonText:this.$LANG('0132', '取消'),
                        customClass:'messageBox', 
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        var vm=this ,v_cond=''
                        if (val =='Y'){
                        v_cond =' set stfg=\''+val+'\',cHKdttm=\''+v_dttm+'\',CHKUSER=\''+this.v_usernm+'\''
                        }else{
                            v_cond =' set stfg=\''+val+'\',cHKdttm=null,CHKUSER=null'
                        }
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ic_stk',p_cond: v_cond},
                        }).then(res=>{      
                            if(res.code =='200')  {     
                                //如果明细记录中有 要生成报告，则产生进料检验报告   
                                if (val =='Y' ){ 
                                    const payload = {corpid:this.v_corpid,p_idseq:row.IDSEQ,p_action:'QACHK_IN#' ,p_user:this.v_username }
                                    this.$axios({
                                        method: 'post',
                                        url:'/xuper_oss/call_package',
                                        data: payload,
                                    }) 
                                }
                                vm.qryTabData()     
                            }else{
                                this.promptWin=true
                                this.prompt=res.message
                            }        
                        }) 
                        
                    }).catch(()=>{})
                }
            })
        },
        //下推生成入库通知
        genSend(){
            let v_arr =[]
            this.nextData.forEach(item=>{
                if (item['SEL'] =='Y'){
                    v_arr.push(item)
                }
            })
            if (v_arr.length ==0){
                this.promptWin =true
                this.prompt =this.$LANG('0791', '请勾选要下推的记录')
            }else{
                this.$confirm(this.$LANG('1621', '你确定下推勾选记录生成入库单吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                })
            }
        },
        chkChg(row){
            if (!row['SENDQTY'] && row['SEL']=='Y'){
                row['SENDQTY'] =row['POQTY']
            }
        },
 
        getMatSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===1){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='QTY'||column.property==='QCQTY'||column.property==='STKQTY'  ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(2) 
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //表行点击事件
        rowClick(row){
            this.v_idseq =row['IDSEQ']            
        },
        qryDtl(){
            if (this.v_idseq){
                this.getNextData(this.v_idseq)
            }
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'450125',p_key2:'lstseq',p_value2:'2',p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //订单明细
        getOrdList(cond){
            //获取所有产品记录且初始化分页记录       
            this.loading =true 
            let v_cond ='' 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid',p_value:this.v_corpid,p_key2:'IDTY',p_value2:'QACHK',p_cond:cond+ v_cond+' ORDER BY '+this.selparam+' desc',p_table:'V_IC_STK_QA'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result
                    this.initPage() 
                    this.loading =false
    
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                    this.loading =false
                }
                
            }) 
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData=[]
            this.v_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq',p_value:idseq,p_table:'V_IC_STKDTL_QA'},
            }).then(res=>{ 
                this.dtlData =res.result
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                    this.v_loading=false
                })                
            })          
        },
        getNextData(idseq){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'idseq',p_value:idseq,p_table:'V_IC_STKDTL_QA'},
            }).then(res=>{ 
                this.dtlData =res.result               
            })          
        },
 
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.pageSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allData.slice(_start,_end);
        },
        selRec(){
           
            this.nextData.forEach((item,index)=>{
                let v_qty =this.v_selAll =='Y'?item['POQTY']:''
                this.nextData.splice(index,1,JSON.parse(JSON.stringify(Object.assign(item,{SEL:this.v_selAll,SENDQTY:v_qty})) ))
            })
            
        },
        editRec(row,val,index){
            this.v_rowIndex =index
            this.saveFlag= val=='Y'?true:false
            this.mainRow =JSON.parse(JSON.stringify(row))
            this.addWin=true  
            this.getDtlData(row.IDSEQ) 
        },
 
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            let v_cond ='' ,v_edcss='' ,v_oper=' like '
            Object.keys(this.v_inputrow).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_inputrow[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_inputrow[`#OPER`+item]){
                        v_oper =this.v_inputrow[`#OPER`+item]
                    }
                    if (v_edcss =='number' ){
                        if (v_oper=='like'){
                            v_oper ='='
                        }
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_inputrow[item] 
                    }else if ( v_edcss=='date'){
                        if (v_oper =='like'){
                            v_cond =v_cond +' and '+item+ ' like \''+this.v_inputrow[item] +'%\''
                        }else {
                            v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_inputrow[item] +'\''
                        }
                    }else{                        
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_inputrow[item]).toLowerCase().trim()+'%\''
                        
                    }                   
                }
            })
            this.getOrdList( cond_+v_cond)
 
        },
  
        //获取表列字段
        getTabField(){
            let vm =this
            vm.tabArr =[]
            vm.vueCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','450125','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol =res.result
                return vm.loadInitialFieldSettings().then(() => {
                const mainFields =vm.sortFieldRows(vm.initCol)
                for (let k=0; k<mainFields.length; k++){
                    const rowField =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(rowField, vm.$store.state.lang),
                        key: rowField.key,
                        align: rowField.align,
                        width: rowField.width,
                        thide:rowField.THIDE,
                        fhide:rowField.FHIDE,
                        edcss:rowField.EDCSS,
                        disabled:rowField.DISABLED,
                        dotnum:rowField.DOTNUM,
                        sortable:rowField.SORTABLE,
                    })
                    let itcol =rowField
                    if (itcol.THIDE=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
      
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        
                                                        <option    value="=" style="height:30px;line-height:30px">=</option>
                                                        <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                        <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                        <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                    </select>
                                                    <input disabled={itcol.EDCSS=='image'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }else if (itcol.EDCSS =='checkbox') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-select placeholder="" size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_inputrow[column.key]} on-change={()=>{this.qryTabData()}}>
                                                        <el-option    value="Y"  label={this.$LANG('2047', '是')} ></el-option>
                                                        <el-option    value="N" label={this.$LANG('2044', '否')} ></el-option>
                                                    </el-select>                                                                                                     
                                                </div>
                                            </div>                                   
                                        )
                                    }else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                                
                                                </div>                        
                                                <div style="display:flex">
                                                    <input disabled={itcol.EDCSS=='image'} value={this.v_inputrow[column.key]} on-keydown={()=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                                </div>
                                            </div>                                   
                                        )
                                    }
                               
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (column.key=='ISSTK' ){
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    } 
                                }else if (column.key=='IDNO') { 
                                    return (                                           
                                        <el-link  underline={false} on-click={()=>{this.repBtn( row)}}><span style=" border-bottom:1px solid red;font-size:13px;;font-weight:700  " title={rowVal}>{rowVal}</span> </el-link>    
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else if (itcol.EDCSS =='checkbox') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                } else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "center",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width:210,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG']=='N'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.recSet(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.recSet(row,'X' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0257', '作废')}</span></el-link>
                                </div>                                
                            )
                        }else if (row['STFG']=='Y'){
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  on-click={()=>{this.editRec(row,'Y',rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-xiashuangjiantou" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={this.cancelBool} on-click={()=>{this.nextGen(row )}} underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0242', '下推')} </span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.recSet(row,'N' )}}  underline={false} ><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link>

                                </div>                                
                            )
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
                })
                
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','450125','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','450125','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        min-width:200px;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
 
    .el-drawer__header{
        padding: 0px;
    }
 
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .table-body-cell-red {
        font-size: 12px !important;
        color: red !important;
        border-width: 1px !important;
        padding-left:2px !important;
        padding-top:0px !important;
        padding-bottom:0px !important;
        border-color: #808695 !important;
        border-bottom:1px solid #808695 !important;
    }
</style>
